<template>
  <!-- <div class="container-fluid main">
    <div class="head-program text-center">
      <h1>Our Program</h1>
      <p class="text-muted mt-3">
        Ikuti Bootcamp untuk meningkatkan<br />
        skill dan bangun portofoliomu
      </p>
      <router-link to="/event">
        <button class="btnProgram">All Program</button>
      </router-link>
    </div>
    <div class="container mt-5">
      <div class="row">
        <div class="col mb-5" v-for="(item , index) in program" :key="index">
          <div class="card rounded-5">
            <div class="bg-image bg-color" :style="`background-image : url(${item.image})`"></div>
            <div class="card-between ms-3 mt-3 fw-bold fs-5">
              {{ item.review == 0 ? '-' : item.review }}
              <span class="align-items-center mb-2">
                <img v-for="(bintang , key) in item.review" :key="key" src="../assets/star.png" alt="start" class="ms-2" />
              </span>
            </div>
            <div class="card-body">
              <h5 class="card-title fw-bold">{{ item.title }}</h5>
              <p class="card-text">{{ item.price == null ? 'Free' : `Rp.${item.price}` }}</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1 card-icon"
                  />
                  {{ item.session }} session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1 card-icon"
                  />
                  {{ item.student }} peserta</span
                >
              </div>
              <router-link v-if="!item.status_joint || item.status_joint == 'waiting'" :to="`/detail-event?event=${item.id}`">
                  <button id="daftarEvent" value="daftarEvent" class="btn rounded-pill w-100 my-4 button-register-course">{{ !item.status_joint ? 'Daftar Sekarang' : 'Menunggu Peninjauan' }}</button>
              </router-link>
              <a v-else-if="item.status_joint == 'join'" :href="`https://dashboard.intelligo.id/user/booth/${item.id}/${item.title.replaceAll(' ','-')}`" target="_blank" class="btn rounded-pill w-100 my-4 button-register-course">Ikuti Sekarang</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="container-fluid main">
    <!-- head component -->
    <div class="head-program text-center">
      <h1>Our Program</h1>
      <p class="text-muted mt-3">
        Ikuti Bootcamp untuk meningkatkan<br />
        skill dan bangun portofoliomu
      </p>
      <router-link to="/event">
        <button class="btnProgram">All Program</button>
      </router-link>
    </div>
    <!-- body component -->
    <div class="container mt-5">
      <div class="row">
        <!-- card 1 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_1.png"
              alt="program 1"
            />
            <!-- valuation -->
            <div class="card-between mt-3 ms-4">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body mx-1">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 3</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1 card-icon"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1 card-icon"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
        <!-- card 2 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_2.png"
              alt="program 2"
            />
            <!-- valuation -->
            <div class="card-between mt-3 ms-4">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body mx-1">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 4</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1 card-icon"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1 card-icon"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
        <!-- card 3 -->
        <div class="col mb-5">
          <div class="card rounded-5">
            <img
              class="card-img-top"
              src="../assets/program_1.png"
              alt="program 3"
            />
            <!-- valuation -->
            <div class="card-between mt-3 ms-4">
              5.0
              <span class="align-items-center mb-2">
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
                <img src="../assets/star.png" alt="start" />
              </span>
            </div>
            <div class="card-body mx-1">
              <h5 class="card-title fw-bold">Bootcamp Intelligo Batch 5</h5>
              <p class="card-text">Rp.1.150.000,00</p>
              <div class="d-flex justify-content-between">
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_video.png"
                    alt="icon video"
                    class="me-1 card-icon"
                  />
                  20 session</span
                >
                <span class="d-flex w-50 align-items-center"
                  ><img
                    src="../assets/icon_peserta.png"
                    alt="icon peserta"
                    class="me-1 card-icon"
                  />
                  120 peserta</span
                >
              </div>
              <button
                type="button"
                class="btn rounded-pill w-100 my-4 button-register-course"
              >
                Daftar Sekarang
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurProgram",
  props: ["program"],
};
</script>

<style scoped>
.btnProgram {
  width: 159px;
  height: 44px;
  border-radius: 100px;
  background: #023047;
  border-radius: #023047;
  font-size: 16px;
  color: #fff;
  margin: 50px 0;
}
.btnProgram:hover {
  background-color: #f74d00;
  color: #fff;
  border: none;
}
.main {
  padding-top: 100px;
  padding-bottom: 100px;
}

.head-program > h1 {
  font-size: 32px !important;
  font-weight: 600;
  color: #023047;
}
.card-text {
  color: #ff865d;
}
.button-register-course {
  background: #023047;
  color: white;
}
.bg-image {
  width: 100%;
  height: 300px;
  background-size: cover;
}

.bg-color {
  background-color: #fcab97;
  border-radius: 2rem;
  background-position: center center;
}

@media screen and (max-width: 350px) {
  .card-icon {
    height: 1.2rem !important;
  }
}
</style>
